<template>
  <div class="table-responsive mt-3 mb-0">
    <table class="table table-bordered custom-table mb-0">
      <thead class="thead-light">
        <tr>
          <th>Sunday</th>
          <th>Monday</th>
          <th>Tuesday</th>
          <th>Wednesday</th>
          <th>Thursday</th>
          <th>Friday</th>
          <th>Saturday</th>
        </tr>
      </thead>
      <tbody>
        <!-- First Row -->
        <tr v-if="firstRowDates && firstRowDates.length">
          <td
            v-for="(item, i) in firstRowDates"
            :key="'firstRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row0_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /First Row -->

        <!-- Second Row -->
        <tr v-if="secondRowDates && secondRowDates.length">
          <td
            v-for="(item, i) in secondRowDates"
            :key="'secondRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row1_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Second Row -->

        <!-- Third Row -->
        <tr v-if="thirdRowDates && thirdRowDates.length">
          <td
            v-for="(item, i) in thirdRowDates"
            :key="'thirdRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row2_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Third Row -->

        <!-- Fourth Row -->
        <tr v-if="fourthRowDates && fourthRowDates.length">
          <td
            v-for="(item, i) in fourthRowDates"
            :key="'fourthRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row3_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Fourth Row -->

        <!-- Fifth Row -->
        <tr v-if="fifthRowDates && fifthRowDates.length">
          <td
            v-for="(item, i) in fifthRowDates"
            :key="'fifthRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row4_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Fifth Row -->

        <!-- Sixth Row -->
        <tr v-if="sixthRowDates && sixthRowDates.length">
          <td
            v-for="(item, i) in sixthRowDates"
            :key="'sixthRow' + i"
            @click.right="showAddMenu(i, $event)"
          >
            <div class="day-div">
              <div class="circle" v-if="item.CalendarDate == todayDate">
                {{ item.Day }}
              </div>
              <span v-else>{{ item.Day }}</span>
            </div>
            <div
              v-for="rec in item.Classes"
              :key="'row5_col' + i + '_' + rec.ClassId"
              :style="'background-color:' + rec.Color"
              class="event-div"
              @click="showEvent(rec, $event)"
            >
              <span
                class="event-span"
                v-html="
                  formatEventName(
                    rec.EventName,
                    rec.Duration,
                    rec.IsPublicHoliday
                  )
                "
              >
              </span>
              <span class="time-span" v-if="!rec.IsPublicHoliday">
                {{ rec.ClassTime }}
              </span>
            </div>
            <div
              v-if="item.MoreCount && item.MoreCount > 0"
              class="more-div"
              @dblclick="showMore(item, $event)"
            >
              {{ item.MoreCount }} more...
            </div>
          </td>
        </tr>
        <!-- /Sixth Row -->
      </tbody>
    </table>

    <!-- Add Menu Right Click -->
    <div
      tabindex="-1"
      class="card m-0 menu"
      id="addMenu"
      ref="addMenu"
      :style="`top:${top};left:${left};display:none`"
      @blur="closeAddMenu"
    >
      <div class="card-body p-0">
        <div @click="newClass" class="menu-item">
          <i class="fa fa-plus-circle mr-1"></i>New Class
        </div>
      </div>
    </div>
    <!-- /Add Menu Right Click -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import $ from "jquery";
export default {
  props: [
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "frequency",
    "locationId",
    "availability",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "selectedDate",
    "selectedCountries",
    "instructorId",
    "instructorName",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      firstRowDates: [],
      secondRowDates: [],
      thirdRowDates: [],
      fourthRowDates: [],
      fifthRowDates: [],
      sixthRowDates: [],
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    todayDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
  },

  methods: {
    showMore(payload, event) {
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      this.$emit("showMore", payload.CalendarDate);
    },
    showEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload.IsPublicHoliday) {
        let obj = {
          eventName: payload.EventName,
          date: payload.DateDisplay,
          country: payload.Country,
        };
        this.$emit("showPublicHoliday", obj);
      } else {
        let obj = {
          classId: payload.ClassId,
          eventName: payload.EventName,
          duration: payload.Duration,
          school: payload.School,
          instructors: payload.Instructors,
          date: payload.DateDisplay,
          dateCal: payload.DateCal,
          time: payload.ClassTime,
          location: payload.Location,
          locationSchoolAddresses: payload.LocationSchoolAddresses,
          fee: payload.ClassFee,
          availability: payload.Availability,
          color: payload.Color,
        };
        this.$emit("showClass", obj);
      }
    },
    //main function
    getClassListByMonth() {
      let param = {
        Token: this.tokenObj.Token,
        SchoolId: this.schoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        Frequency: this.frequency,
        LocationId: this.locationId,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        Availability: this.availability,
        InstructorId: this.instructorId,
        InstructorName: this.instructorName,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
      };
      this.$store.state.isLoading = true;
      API.class
        .getClassListByMonth(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let records = response.data.data;
            this.loadCalendar(records);
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    loadCalendar(records) {
      this.firstRowDates = [];
      this.secondRowDates = [];
      this.thirdRowDates = [];
      this.fourthRowDates = [];
      this.fifthRowDates = [];
      this.sixthRowDates = [];
      let index = 0;
      //populate first row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].DayOfWeek == dayOfWeek) {
          if (records[index].Classes && records[index].Classes.length) {
            let totalRecordsShown = this.getTotalRecordsShown(
              records[index].Classes
            );
            records[index].MoreCount =
              records[index].Classes.length - totalRecordsShown;
            records[index].Classes.splice(
              records[index].Classes.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.firstRowDates.push(records[index]);
          index++;
        } else {
          this.firstRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Classes: [],
          });
        }
      }
      //populate second row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Classes && records[index].Classes.length) {
          let totalRecordsShown = this.getTotalRecordsShown(
            records[index].Classes
          );
          records[index].MoreCount =
            records[index].Classes.length - totalRecordsShown;
          records[index].Classes.splice(
            records[index].Classes.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.secondRowDates.push(records[index]);
        index++;
      }
      //populate third row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Classes && records[index].Classes.length) {
          let totalRecordsShown = this.getTotalRecordsShown(
            records[index].Classes
          );
          records[index].MoreCount =
            records[index].Classes.length - totalRecordsShown;
          records[index].Classes.splice(
            records[index].Classes.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.thirdRowDates.push(records[index]);
        index++;
      }
      //populate fourth row
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (records[index].Classes && records[index].Classes.length) {
          let totalRecordsShown = this.getTotalRecordsShown(
            records[index].Classes
          );
          records[index].MoreCount =
            records[index].Classes.length - totalRecordsShown;
          records[index].Classes.splice(
            records[index].Classes.length - records[index].MoreCount,
            records[index].MoreCount
          );
        }
        this.fourthRowDates.push(records[index]);
        index++;
      }
      //populate fifth row
      if (!Object.prototype.hasOwnProperty.call(records, index)) return;
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (Object.prototype.hasOwnProperty.call(records, index)) {
          if (records[index].Classes && records[index].Classes.length) {
            let totalRecordsShown = this.getTotalRecordsShown(
              records[index].Classes
            );
            records[index].MoreCount =
              records[index].Classes.length - totalRecordsShown;
            records[index].Classes.splice(
              records[index].Classes.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.fifthRowDates.push(records[index]);
          index++;
        } else {
          this.fifthRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Classes: [],
          });
        }
      }
      //populate sixth row
      if (!Object.prototype.hasOwnProperty.call(records, index)) return;
      for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
        if (Object.prototype.hasOwnProperty.call(records, index)) {
          if (records[index].Classes && records[index].Classes.length) {
            let totalRecordsShown = this.getTotalRecordsShown(
              records[index].Classes
            );
            records[index].MoreCount =
              records[index].Classes.length - totalRecordsShown;
            records[index].Classes.splice(
              records[index].Classes.length - records[index].MoreCount,
              records[index].MoreCount
            );
          }
          this.sixthRowDates.push(records[index]);
          index++;
        } else {
          this.sixthRowDates.push({
            Day: null,
            CalendarDate: "",
            DayOfWeek: null,
            Classes: [],
          });
        }
      }
    },
    //helper
    getTotalRecordsShown(classes) {
      let rowsOccupied = 0;
      let totalRecordsShown = 0;
      for (let rec of classes) {
        if (rec.IsPublicHoliday == true) rowsOccupied++;
        else rowsOccupied += 2;
        totalRecordsShown++;
        if (rowsOccupied >= 6) break;
      }
      let phRecords = classes.filter((c) => c.IsPublicHoliday == true);
      let classRecords = classes.filter((c) => c.IsPublicHoliday == false);
      if (phRecords.length + classRecords.length * 2 > 6) totalRecordsShown--;
      return totalRecordsShown;
    },
    formatEventName(eventName, duration, isPh) {
      if (!eventName) return "";
      let maxChars = isPh ? 27 : 16;
      let output = eventName;
      if (eventName.length > maxChars)
        output = eventName.substring(0, maxChars - 3) + "...";
      if (!isPh) output = output + "<br/>" + duration;
      return output;
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    //right click menu add
    showAddMenu(colIndex, event) {
      event.preventDefault();
      if (
        this.tokenObj.UserType == this.userTypeMainAdmin ||
        this.tokenObj.UserType == this.userTypeSchoolAdmin ||
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin &&
          this.$route.path.includes("/schooladmin/"))
      ) {
        this.$nextTick(() => {
          $(document).scrollTop(this.scrollTop);
        });
        $("#addMenu").show();
        this.$refs.addMenu.focus();
        let calDivOuterHeight = $(".cal-div").outerHeight();
        let calDivOuterWidth = $(".cal-div").outerWidth();
        if (calDivOuterHeight >= 300) {
          calDivOuterHeight = 0;
        } else {
          calDivOuterHeight = calDivOuterHeight + 20;
          calDivOuterWidth = 0;
        }

        let headerHeight = $(".header").outerHeight();
        let contentPaddingTop = 30;
        let pageHeaderHeight = $(".page-header").outerHeight();
        let pageHeaderMarginBottom = 30;
        let rowFilter1Height = $(".row-filter-1").outerHeight();
        let rowFilter2Height = $(".row-filter-2").outerHeight();
        let rowFilter3Height = $(".row-filter-3").outerHeight();
        let rowFilter4Height = $(".row-filter-4").outerHeight();
        let rowFilter5Height = $(".row-filter-5").outerHeight();
        let navigationDivHeight = $(".navigation-div").outerHeight();
        let allAboveElementsHeight =
          headerHeight +
          contentPaddingTop +
          pageHeaderHeight +
          pageHeaderMarginBottom +
          rowFilter1Height +
          rowFilter2Height +
          rowFilter3Height +
          rowFilter4Height +
          rowFilter5Height +
          8 +
          20 +
          navigationDivHeight +
          16 +
          calDivOuterHeight;
        let top = event.y + this.scrollTop - allAboveElementsHeight;

        let sideBarOuterWidth = $(".sidebar").outerWidth();
        let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
        let addMenuOuterWidth = $(".menu").outerWidth();
        let left =
          event.x -
          (allLeftElementsWidth + (colIndex == 6 ? addMenuOuterWidth + 10 : 0));
        this.top = top + "px";
        this.left = left + "px";
      }
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    newClass() {
      this.$router.push({
        name:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? "mainAdminClassAdd"
            : "schoolAdminClassAdd",
      });
    },
  },

  created() {
    this.getClassListByMonth();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
  },
};
</script>

<style scoped>
.table-responsive {
  position: relative;
}
table {
  table-layout: fixed;
}
.table.custom-table > tbody > tr > td {
  padding-left: 3px !important;
  padding-right: 3px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  vertical-align: top !important;
  height: 125px;
  cursor: pointer;
}
.day-div {
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  height: 25px;
  display: flex;
}
.circle {
  color: #fff;
  width: 22px;
  height: 22px;
  background-color: #3884cc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1px;
}
.event-div {
  opacity: 1;
  margin-bottom: 1px;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2.5px;
  padding-bottom: 2.5px;
  cursor: pointer;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  width: 100%;
  letter-spacing: -0.5px;
  position: relative;
}
.event-div:hover {
  opacity: 1;
}
.event-span {
  color: white;
  font-size: 10px;
  width: 100%;
  line-height: 13px;
}
.time-span {
  color: white;
  font-size: 9px;
  width: 40px;
  text-align: right;
  padding-top: 2px;
}
.more-div {
  font-size: 10px;
  color: grey;
}
.table th {
  text-align: center;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
</style>




// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassListCalendarFormatMonth.vue